import React from 'react';

type Stage =
  | 'New' |'Contacted' |'Interested' |'Counseling Scheduled' |'Applied' |'Converted' |'Lost';

const stageConfig: Record<Stage, { bg: string; text: string; dot: string }> = {
  New: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500' },
  Contacted: { bg: 'bg-sky-50', text: 'text-sky-700', dot: 'bg-sky-500' },
  Interested: { bg: 'bg-violet-50', text: 'text-violet-700', dot: 'bg-violet-500' },
  'Counseling Scheduled': { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500' },
  Applied: { bg: 'bg-orange-50', text: 'text-orange-700', dot: 'bg-orange-500' },
  Converted: { bg: 'bg-green-50', text: 'text-green-700', dot: 'bg-green-500' },
  Lost: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-400' },
};

export default function StageBadge({ stage }: { stage: Stage }) {
  const config = stageConfig[stage] ?? stageConfig['New'];
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold ${config.bg} ${config.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {stage}
    </span>
  );
}